module.exports = __webpack_public_path__ + "img/certificate_ogr_220362915_00.a694a530.png";